// extracted by mini-css-extract-plugin
export var currencyInput = "_of-1";
export var currencySymbol = "_of-0";